var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_2497_15376)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 16.2273C5.5 10.5789 10.0789 6 15.7273 6C18.4358 6 20.8985 7.05292 22.7282 8.77178L8.27178 23.2282C6.55292 21.3985 5.5 18.9358 5.5 16.2273ZM6.85698 24.643C4.77647 22.4508 3.5 19.4881 3.5 16.2273C3.5 9.47434 8.97434 4 15.7273 4C18.9881 4 21.9508 5.27647 24.143 7.35698L25.7929 5.70711C26.1834 5.31658 26.8166 5.31658 27.2071 5.70711C27.5976 6.09763 27.5976 6.7308 27.2071 7.12132L6.62132 27.7071C6.2308 28.0976 5.59763 28.0976 5.20711 27.7071C4.81658 27.3166 4.81658 26.6834 5.20711 26.2929L6.85698 24.643ZM15.7273 26.4545C15.1572 26.4545 14.598 26.4079 14.0533 26.3182L12.3807 27.9909C13.4442 28.2929 14.5669 28.4545 15.7273 28.4545C18.7651 28.4545 21.5442 27.3467 23.6826 25.513C23.7306 25.6165 23.7973 25.7135 23.8827 25.7989L29.7918 31.708C30.1824 32.0985 30.8155 32.0985 31.206 31.708C31.5966 31.3175 31.5966 30.6843 31.206 30.2938L25.297 24.3847C25.2116 24.2994 25.1147 24.2327 25.0112 24.1846C26.846 22.046 27.9545 19.2661 27.9545 16.2273C27.9545 15.0669 27.7929 13.9442 27.4909 12.8807L25.8182 14.5533C25.9079 15.098 25.9545 15.6572 25.9545 16.2273C25.9545 21.8756 21.3756 26.4545 15.7273 26.4545Z",
    fill: "#00D98B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2497_15376",
    x1: 9,
    y1: 9.5,
    x2: 33.5,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2E22"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/EmptySearch.788cb10f0c6aacb0244faf2926ac4e53.svg";
export { ForwardRef as ReactComponent };